import { Currency, QualityCurrency } from '../../schemas';

export type CurrencyEnum = Record<string, string>;

export type CurrencyOption = {
  label: string;
  value: string;
};

export const getCurrencyOptions = (currencyEnum: CurrencyEnum): CurrencyOption[] =>
  Object.values(currencyEnum).map((currency) => ({
    label: currency,
    value: currency,
  }));

export const isCurrencyInEnum = <TCurrencyEnum extends CurrencyEnum>(
  currency: string,
  currencyEnum: TCurrencyEnum
): currency is TCurrencyEnum[keyof TCurrencyEnum] => Object.values(currencyEnum).includes(currency);

export const CURRENCY_OPTIONS: CurrencyOption[] = [Currency.USD, Currency.GBP, Currency.EUR, Currency.RSD].map(
  (currency) => ({
    label: currency,
    value: currency,
  })
);

export const QUALITY_CURRENCY_OPTIONS: CurrencyOption[] = getCurrencyOptions(QualityCurrency);

export const isAcceptedCurrency = (currency: string): currency is Currency =>
  Currency[currency as keyof typeof Currency] !== undefined;
